import React from "react";

import { isNumber } from "../../util/validator";

import { CategoryContainer } from "../../components/CategoryContainer";
import { TextFieldRHF } from "../../components/RHFWrappedComponents";

export function CurrentSchool() {
  return (
    <CategoryContainer title="Your current school standing">
      <TextFieldRHF
        name="academicInfo.currentSchool.classRank"
        rules={{
          validate: {
            isNumber: isNumber([0, 100]),
          },
        }}
        textFieldLabel="Class Rank (Percentile)"
        InputProps={{
          endAdornment: "%",
        }}
      />
    </CategoryContainer>
  );
}
